import type { Radian } from "../types/Units"

// Type-preserving functions (return same branded type as input)
export const Abs: <T extends number>(x: T) => T = Math.abs as never
export const Ceil: <T extends number>(x: T) => T = Math.ceil as never
export const Floor: <T extends number>(x: T) => T = Math.floor as never
export const Fround: <T extends number>(x: T) => T = Math.fround as never
export const Round: <T extends number>(x: T) => T = Math.round as never
export const Trunc: <T extends number>(x: T) => T = Math.trunc as never

// Min/Max preserve type when all args are same type
export const Max: <T extends number>(...values: T[]) => T = Math.max as never
export const Min: <T extends number>(...values: T[]) => T = Math.min as never

// Trig functions (input Radian, output number)
export const Cos: (x: Radian) => number = Math.cos
export const Sin: (x: Radian) => number = Math.sin
export const Tan: (x: Radian) => number = Math.tan

// Inverse trig (input number, output Radian)
export const Acos: (x: number) => Radian = Math.acos as never
export const Asin: (x: number) => Radian = Math.asin as never
export const Atan: (x: number) => Radian = Math.atan as never
export const Atan2: (y: number, x: number) => Radian = Math.atan2 as never

// Functions that always return plain number
export const Exp: (x: number) => number = Math.exp
export const Hypot: (...values: number[]) => number = Math.hypot
export const Log: (x: number) => number = Math.log
export const Pow: (x: number, y: number) => number = Math.pow
export const Random: () => number = Math.random
export const Sign: (x: number) => number = Math.sign
export const Sqrt: (x: number) => number = Math.sqrt

// Constants
export const PI: Radian = Math.PI as Radian
export const E: number = Math.E
